// Los paneles de comercios (Cupido Delivery y Cupido Descuentos) pueden tener su dirección propia,
// así se instalan como apps separadas de la de usuarios (ver server/lib/paneles.js).
// El servidor la deja en <meta name="cupido-paneles">; sin ella, los paneles están en este mismo sitio.
const origenPaneles = () => document.querySelector('meta[name="cupido-paneles"]')?.content || '';

// Ir a un panel: si está en otra dirección, se cambia de página; si no, navega dentro de la app.
export function irAlPanel(ruta, navigate) {
  const origen = origenPaneles();
  if (origen && origen !== window.location.origin) window.location.href = origen + ruta;
  else navigate(ruta);
}
